module.exports = __webpack_public_path__ + "static/media/maynooth.494716a6.png";